/**
 * Icon sprite delivery — shared constants.
 *
 * The full SVG sprite is served once from the {@link ICON_SPRITE_URL} route (a
 * cacheable, same-origin file) and injected into the DOM client-side by
 * `<IconSpriteLoader>`, so the design system's `<Icon>` (which references
 * symbols by `#name`) resolves against it. This keeps the ~355KB sprite (and
 * its RSC-payload duplicate) out of every page's HTML — a first-paint (FCP)
 * win. Icons reference symbols by `#name` on both server and client, so there
 * is no hydration mismatch.
 */

/** Same-origin route serving the full sprite (see src/app/icons/sprite.svg). */
export const ICON_SPRITE_URL = '/icons/sprite.svg';
